export const AUTH_LOGOUT_REASONS = Object.freeze({
  explicitReturnToLogin: 'explicit_return_to_login',
  sessionTimeout: 'session_timeout',
  sidebarLogout: 'sidebar_logout',
  workspaceAccessDenied: 'workspace_access_denied',
});

const allowedLogoutReasons = new Set(Object.values(AUTH_LOGOUT_REASONS));

export function normalizeAuthLogoutReason(reason) {
  const normalized = typeof reason === 'string' ? reason.trim() : '';
  return allowedLogoutReasons.has(normalized)
    ? normalized
    : AUTH_LOGOUT_REASONS.explicitReturnToLogin;
}
